import React from 'react';
import styles from './index.module.css';
import logo from '../../images/4bC-logo 1.svg';

import CarouselSection from './components/CarouselSection';
import LoginForm from './components/LoginForm';

const LoginScreen = () => {
  return (
    <div className={styles['login2-container']}>
      <nav className={styles.navbar}>
        <a href="https://4basecare.com/" target="_blank" rel="noreferrer" className={styles['logo-link']}>
          <img src={logo} alt="4baseCare Logo" className={styles['company-logo']} />
        </a>
      </nav>

      <div className={styles['main-content']}>
        <div className="container-fluid h-100 px-0">
          <div className="row h-100 mx-0">
            <CarouselSection />
            <LoginForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
